module.exports = __webpack_public_path__ + "img/user.4096fd7e.png";